import ProviderSpecificFieldInput from '@withdrawals/components/ProviderSpecificFieldInput'
import type { ProviderSpecificField } from 'mmfintech-backend-api/types'
import { isValidArray } from 'mmfintech-commons'
import type { UseFormValuesOutput } from 'mmfintech-commons/types'

import styles from './ProviderSpecificFields.module.scss'

type ProviderSpecificFieldsProps = {
  setup: ProviderSpecificField[]
  formValues: UseFormValuesOutput
  beneficiaryName?: string
}

const ProviderSpecificFields = (props: ProviderSpecificFieldsProps) => {
  const { setup, formValues, beneficiaryName } = props

  return isValidArray(setup) ? (
    <div className={styles['provider-specific-fields']} data-test='provider-specific-fields'>
      {setup.map(entry => (
        <ProviderSpecificFieldInput
          key={entry.fieldName}
          setup={entry}
          formValues={formValues}
          beneficiaryName={beneficiaryName}
        />
      ))}
    </div>
  ) : null
}

export default ProviderSpecificFields
